var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
      staticClass: "app-main-inner",
      attrs: {
        id: "app",
        visible: _vm.innerVisible,
        title: _vm.$t("queryJob.SelectMainOrder"),
        width: "1000px",
        "close-on-click-modal": false,
        "append-to-body": ""
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: function($event) {
          return _vm.closeHandler()
        }
      }
    },
    [
      _c(
        "div",
        { staticClass: "app-main-inner-row" },
        [
          _c(
            "el-form",
            {
              staticStyle: { width: "100%" },
              attrs: { "label-width": "80px", "label-position": "left" }
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("Payment.mbl") } },
                        [
                          _c("el-input", {
                            attrs: { no: "1" },
                            model: {
                              value: _vm.form.mawbNo,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "mawbNo", $$v)
                              },
                              expression: "form.mawbNo"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: _vm.$t("SeaExport.AirlineCompany") }
                        },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "2",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { airCmp: true },
                              "callback-method-type": "value",
                              "default-value": _vm.form.airCompany || "",
                              "callback-params": { key: "airCompany" }
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("queryJob.bookingAgent") } },
                        [
                          _c("cargo-advance-select", {
                            attrs: {
                              no: "3",
                              filterable: "",
                              "select-type":
                                _vm.selectTypeNames.basic_data_Company,
                              "method-params": { bookingAgent: true },
                              "callback-method-type": "value",
                              "default-value": _vm.form.bookingAgent || "",
                              "callback-params": { key: "bookingAgent" }
                            },
                            on: { parentCallBack: _vm.getValueFromChild }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_RegistrationDate")
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "3",
                              clearable: "",
                              type: "daterange",
                              format: "yyyy-MM-dd",
                              "value-format": "yyyy-MM-dd",
                              "unlink-panels": "",
                              "range-separator": "-",
                              "start-placeholder": _vm.$t(
                                "CargoMsg.Cargo_DateFrom"
                              ),
                              "end-placeholder": _vm.$t(
                                "CargoMsg.Cargo_CompleteDate"
                              )
                            },
                            model: {
                              value: _vm.form.dateCreated,
                              callback: function($$v) {
                                _vm.$set(_vm.form, "dateCreated", $$v)
                              },
                              expression: "form.dateCreated"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { staticStyle: { "text-align": "left" } },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { no: "4", type: "primary" },
                          on: {
                            click: function($event) {
                              return _vm.queryHandler(true)
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("common.btn.query")) + " ")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { no: "5", type: "primary" },
                          on: { click: _vm.resetSearch }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Empty")) + " ")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "app-main-inner-row row-grid",
          staticStyle: { "min-height": "350px", "padding-top": "10px" }
        },
        [
          _c("cargo-ag-grid", {
            staticStyle: { width: "100%", height: "350px" },
            attrs: {
              "grid-params": _vm.gridParams,
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "show-side-bar": false,
              "row-data": _vm.rowData
            },
            on: {
              "update:gridParams": function($event) {
                _vm.gridParams = $event
              },
              "update:grid-params": function($event) {
                _vm.gridParams = $event
              },
              gridReady: function(params) {
                return (_vm.gridApi = params.api)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "app-main-inner-row row-pagination" },
        [
          _c("cargo-pagination", {
            attrs: {
              total: _vm.searchConditions.total,
              page: _vm.searchConditions.pageNum,
              limit: _vm.searchConditions.pageSize
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.searchConditions, "pageNum", $event)
              },
              "update:limit": function($event) {
                return _vm.$set(_vm.searchConditions, "pageSize", $event)
              },
              pagination: function($event) {
                return _vm.queryHandler(false)
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        {
          staticStyle: { display: "flex", "justify-content": "space-between" },
          attrs: { slot: "footer" },
          slot: "footer"
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.type === "input",
                  expression: "type === 'input'"
                }
              ],
              staticStyle: { display: "flex", flex: "1" }
            },
            [
              _c(
                "span",
                { staticStyle: { "font-size": "12px", "line-height": "28px" } },
                [_vm._v(_vm._s(_vm.$t("queryJob.ManualInput")))]
              ),
              _c("el-input", {
                staticStyle: { width: "260px", "margin-right": "5px" },
                attrs: { no: "6" },
                model: {
                  value: _vm.form.inputMAWBNo,
                  callback: function($$v) {
                    _vm.$set(_vm.form, "inputMAWBNo", $$v)
                  },
                  expression: "form.inputMAWBNo"
                }
              }),
              _c(
                "el-button",
                {
                  attrs: { no: "7", type: "primary" },
                  on: { click: _vm.useInputHandler }
                },
                [_vm._v(_vm._s(_vm.$t("WriteOff.use")))]
              )
            ],
            1
          ),
          _c("div", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.type !== "input",
                expression: "type !== 'input' "
              }
            ],
            staticStyle: { display: "flex", flex: "1", width: "260px" }
          }),
          _c(
            "div",
            { staticStyle: { display: "flex" } },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "8", type: "primary" },
                  on: { click: _vm.enterHandler }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")) + " ")]
              ),
              _c(
                "el-button",
                { attrs: { no: "9" }, on: { click: _vm.closeHandler } },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }